/**
 * Mappe les codes d'erreur métier de la RPC delete_contact_safely (00159)
 * vers un message FR affichable. Les codes sont portés par error.message
 * côté Supabase (cf. useContactActions.deleteContactSafely).
 * CRM-15 / suppression sûre d'une fiche contact.
 */
export function deleteContactErrorMessage(err: unknown): string {
  const code = typeof err === 'string' ? err : err instanceof Error ? err.message : '';
  switch (code) {
    case 'contact_requires_superadmin':
      return 'Fiche liée à un paiement encaissé ou un équipage actif — suppression réservée au superadmin.';
    case 'contact_force_required':
      return "Cochez la case de confirmation pour supprimer malgré l'alerte.";
    case 'contact_delete_forbidden':
      return "Vous n'avez pas les droits pour supprimer une fiche.";
    case 'contact_not_found':
      return 'Fiche introuvable (déjà supprimée ?).';
    case 'authentication_required':
      return 'Session expirée, veuillez vous reconnecter.';
    default:
      return 'Erreur lors de la suppression';
  }
}
